const addDayToDate = (date) => {
  const tempDate = new Date(date);
  return new Date(tempDate.setDate(tempDate.getDate() + 1))
    .toISOString()
    .split("T")[0];
};

export default function createFilterQuery(data, fields, dataToHandleWithIn) {
  let queryParts = Object.entries(data)
    .map(([key, value]) => {
      let queryPart;
      const valueType = fields.find((field) => field.name === key).type;
      const regexIsTypeString =
        valueType.match(/string/i) || valueType.match(/GlobalID/i);
      const regexIsTypeDate = valueType.match(/date/i);
      // if it is a ranged input, we need to handle it differently
      // in case of array index zero is the from value and index one is the to value
      //  value = [from, to]
      if (!Array.isArray(value)) {
        // eslint-disable-next-line no-nested-ternary
        queryPart = regexIsTypeString
          ? `${key} = '${value}'`
          : regexIsTypeDate
          ? `${key} = date'${value}'`
          : `${key} = ${value}`;
      } else if (value[0] && value[1]) {
        // if array has 2 elements, it is a ranged input and it will has between statement
        queryPart = !regexIsTypeDate
          ? `${key} BETWEEN ${value[0]} AND ${value[1]}`
          : `${key} >= date'${value[0]}' AND ${key} <= date'${addDayToDate(
              value[1]
            )}'`;
      } else if (value[0] && !value[1]) {
        // if array has 1 element and its the first one only, it is a ranged input and it will has greater than statement
        queryPart = !regexIsTypeDate
          ? `${key} >= ${value[0]}`
          : `${key} >= date'${value[0]}'`;
      } else if (!value[0] && value[1]) {
        // if array has 1 element and its the first one only, it is a ranged input and it will has greater than statement

        queryPart = !regexIsTypeDate
          ? `${key} <= ${value[1]}`
          : `${key} >= date'1900-1-1' AND ${key} <= date'${addDayToDate(
              value[1]
            )}'`;
      }
      return queryPart;
    })
    .join(" AND ");
  if (dataToHandleWithIn) {
    const dataToHandleWithInQuery = Object.entries(dataToHandleWithIn)
      .map(([key, value]) => `${key} IN (${value})`)
      .join(" AND ");
    queryParts = `${queryParts}${
      queryParts && dataToHandleWithInQuery && " AND "
    }${dataToHandleWithInQuery}`;
  }

  return queryParts;
}
